/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

import { StylingContextState } from 'context/Styling';

export const mfaPromptModalStyles = ({ colors, viewport: { md } }: StylingContextState) => ({
  content: css`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  `,
  header: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.25rem;
    text-align: center;
  `,
  logo: css`
    height: 48px;
    width: auto;
  `,
  heading: css`
    margin: 0 !important;
    font-size: 1.5rem !important;
    font-weight: 700 !important;
    line-height: 1.3 !important;
    color: ${colors.text.primary};
  `,
  description: css`
    margin: 0 !important;
    color: ${colors.text.secondary};
    line-height: 1.5 !important;
    text-align: center;
  `,
  actions: css`
    display: flex;
    flex-direction: ${md ? 'row' : 'column-reverse'};
    gap: 1rem;
    align-items: center;
    justify-content: center;
    margin-top: 0.5rem;
  `,
  secondaryButton: css`
    min-width: ${md ? '140px' : 'auto'};
    height: 32px !important;
    line-height: 30px !important;
    padding: 0 15px !important;

    &:hover {
      background-color: ${colors.action.hover} !important;
      color: ${colors.text.primary} !important;
    }

    &:focus {
      background-color: ${colors.action.hover} !important;
      color: ${colors.text.primary} !important;
    }
  `,
  primaryButton: css`
    min-width: ${md ? '140px' : 'auto'};
    height: 32px !important;
    line-height: 30px !important;
    padding: 0 15px !important;
  `,
});
